// import { auth, isAdmin, isUser } from "@/router/auth";
import { RouteConfig } from "vue-router";
const routes: Array<RouteConfig> = [ {
                path: '/market',
                component: () => import(/* webpackChunkName: "ty-marketplace" */ '../views/MarketplaceShops.vue'),
        },{
          path: '/market/:shop_username',
          name: 'ty-marketplace-shop',
          component: () => import(/* webpackChunkName: "ty-marketplace-shop" */ '../views/MarketplaceShopProfile.vue'),
        }
]

export default routes;